export default __webpack_public_path__ + "static/media/soundcloud.f51d761d.svg";